import React, { useEffect, useState } from "react";
import { signInWithRedirect } from "aws-amplify/auth";
import logo from "../src/assets/logos.jpg";

const LoginPage = () => {
  const [err, setErr] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");
    const errorDescription = params.get("error_description");
    if (error || errorDescription) {
      setErr(`${error || "auth_error"}: ${errorDescription || ""}`.trim());
    }
  }, []);

  const handleHostedSignIn = async () => {
    setErr("");
    try {
      await signInWithRedirect();
    } catch (e) {
      setErr(e?.message || "Failed to start sign-in redirect");
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-orange-500 via-orange-600 to-amber-600">
      {/* MAIN CONTENT */}
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="bg-white/95 backdrop-blur rounded-2xl shadow-2xl w-full max-w-md p-8 border border-white/40">
          {/* Brand */}
          <div className="text-center mb-6">
            <div className="mx-auto mb-4 h-14 w-14 rounded-2xl bg-orange-100 flex items-center justify-center">
              <img
                src={logo}
                alt="Smoky Hill Engineering"
                className="h-9 w-9 object-contain"
              />
            </div>

            <h1 className="text-3xl font-bold text-gray-900">SmokyQ</h1>
            <p className="mt-2 text-gray-600">
              Quality • Safety • Compliance — all in one place.
            </p>
          </div>

          {err && (
            <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm">
              {err}
            </div>
          )}

          {/* Hosted UI sign in */}
          <button
            type="button"
            onClick={handleHostedSignIn}
            className="w-full py-3 rounded-xl font-semibold text-white shadow-lg hover:shadow-xl transition
                        bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700"
          >
            Sign in
          </button>

          <div className="mt-5 text-xs text-gray-500 leading-relaxed">
            Accounts are created by your administrator. You’ll receive an
            invitation email with instructions.
            <br />
            If you forgot your password, use the “Forgot password” option on the
            sign-in page.
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="w-full py-3 text-center text-[11px] text-orange-50/80 bg-black/5">
        © 2026 Smoky Hill Engineering · All rights reserved.
      </footer>
    </div>
  );
};

export default LoginPage;
